import { createFileRoute } from "@tanstack/react-router";
import { RouteError, RouteNotFound } from "@/components/route-boundaries";
import { LegalPage, legalHead, type LegalSection } from "@/components/public/legal-page";

export const Route = createFileRoute("/_public/disclaimer")({
  head: () =>
    legalHead(
      "/disclaimer",
      "إخلاء المسؤولية",
      "حدود الخدمة: إرشاد تربوي ودعم نفسي، وليس تشخيصاً طبياً. الخدمة ليست للحالات الطارئة.",
    ),
  errorComponent: RouteError,
  notFoundComponent: RouteNotFound,
  component: DisclaimerPage,
});

const ar: LegalSection[] = [
  {
    title: "في حالة الطوارئ",
    body: "هذه الخدمة ليست للحالات الطارئة. إذا كان هناك خطر على حياة أحد أو على سلامته، تواصل فوراً مع خدمات الطوارئ المحلية أو توجّه إلى أقرب مستشفى.",
  },
  {
    title: "طبيعة الخدمة",
    body: "ما نقدّمه إرشاد تربوي ودعم نفسي تعليمي، وليس تشخيصاً طبياً ولا علاجاً. عند الحاجة ننصح بمراجعة طبيب أو مختص مرخّص.",
  },
  {
    title: "البوصلة الذكية",
    body: "تقرير البوصلة الذكية يُصاغ بمساعدة الذكاء الاصطناعي ويراجعه فريق د. سارة قبل إرساله. هو أداة توجيه، وليس ضماناً للقبول الجامعي أو لفرص العمل.",
  },
  {
    title: "محتوى المدوّنة",
    body: "المقالات معلومات عامة تساعد على الفهم، ولا تغني عن استشارة تناسب حالة طفلك بالتحديد.",
  },
];

const en: LegalSection[] = [
  {
    title: "In an emergency",
    body: "This service is not for emergencies. If anyone's life or safety is at risk, contact your local emergency services or go to the nearest hospital immediately.",
  },
  {
    title: "Nature of the service",
    body: "Our guidance is educational and psychological support. It is not a medical diagnosis or treatment. Where needed, please see a licensed doctor or specialist.",
  },
  {
    title: "Smart Bousala",
    body: "The Smart Bousala report is AI-assisted and reviewed by Dr. Sara's team before it is sent. It is guidance, not a guarantee of university admission or employment.",
  },
  {
    title: "Blog content",
    body: "Articles are general information and are not a substitute for advice tailored to your child.",
  },
];

function DisclaimerPage() {
  return (
    <LegalPage
      kicker="إخلاء المسؤولية"
      title="إخلاء المسؤولية"
      updatedAr="تشرين الأول 2026"
      sections={ar}
      enTitle="Disclaimer"
      updatedEn="October 2026"
      enSections={en}
    />
  );
}
